import { render } from "./CadastrarNoticia.vue?vue&type=template&id=c1beea38"
import script from "./CadastrarNoticia.vue?vue&type=script&lang=js"
export * from "./CadastrarNoticia.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__